/**
 * West African CFA franc.
 */
export var XOF = {
  code: 'XOF',
  base: 10,
  exponent: 0
};